import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {AlertCircleIcon, ArrowLeftIcon} from '@/components/ui/icon/Icon'
import {TKey, useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {generatePath} from 'react-router-dom'

export type ProjectOperation = 'renew' | 'transform' | 'extendsCycle' | 'reopen' | 'earlyClosing'

const operationTitleKey = {
    renew: 'projects:renew_project_error_title',
    transform: 'projects:transform_project_error_title',
    extendsCycle: 'projects:extends_project_error_title',
    reopen: 'projects:reopen_project_error_title',
    earlyClosing: 'projects:early_closing_project_error_title'
} as const satisfies Record<ProjectOperation, TKey>

/**
 * Full-page "operation not available" box shown when a project doesn't meet the
 * eligibility rules for the requested operation (see the can* predicates in
 * projects/utils). Used by the operation pages to block direct URL access.
 */
export const ProjectOperationNotAllowedBox = ({
    operation,
    projectId
}: {
    operation: ProjectOperation
    projectId: string
}) => {
    const {t} = useTranslation()

    return (
        <ErrorBox
            title={t(operationTitleKey[operation])}
            icon={<AlertCircleIcon />}
            cta={
                <ButtonLink
                    size="xl"
                    variant="secondary"
                    to={generatePath(routes.PROJECT_DETAILS_PROJECT_DATA.handle.path, {id: projectId})}
                >
                    <ArrowLeftIcon />
                    {t('commons:back')}
                </ButtonLink>
            }
        />
    )
}
